import { useFormik } from "formik";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Input, Form } from "components/Form";
import { Button } from "components/Button";
import { Loader } from "components/Loader";
import { parseErrorMessage } from "utils";
import { toast } from "Layout/slice";
import { useNavigation } from "utils/navigate";
import { helpcenterRequestTypes } from "utils/constants";
import { userDetailSelect } from "Layout/slice/selector";
import { Heading } from "style/components/Heading.styles";
import { sendContactOrFeatureDetails } from "../../service";
import { loggedInState } from "features/Auth/slice/selector";
import { HelpCenterSubCardContainer, Divider } from "../HelpCenter.styles";
import { initialValues, validationSchema } from "../../validation";
import { IconClose } from "assets/icons";

const ContactUs = ({ data, postSubmit, handleMenuClose }) => {
  const dispatch = useDispatch();
  const userDetail = useSelector(userDetailSelect);
  const isLoggedInState = useSelector(loggedInState);
  const location = useLocation();

  const { navigateToV2 } = useNavigation();

  const [defaultValues, setDefaultValues] = useState({
    name: "",
    email: "",
    description: "",
  });

  useEffect(() => {
    const values = {};

    if (userDetail) {
      values.name = userDetail
        ? `${userDetail.first_name} ${userDetail.last_name}`
        : "";
      values.email = userDetail ? userDetail.email : "";
    }
    if (data) {
      values.description = data?.description || "";
    }

    setDefaultValues(values);
  }, [location?.state, userDetail]);

  const handleSubmit = async (values) => {
    try {
      await sendContactOrFeatureDetails({
        ...values,
        request_type: helpcenterRequestTypes.contactUs,
      });
      formik.resetForm();
      if (postSubmit) postSubmit();

      setDefaultValues({
        ...defaultValues,
        description: "",
      });
      navigateToV2({
        state: null,
      });
      dispatch(
        toast({
          type: "info",
          body: "Your query has been received, we will get back to you soon!",
        })
      );
    } catch (error) {
      console.error(error);
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const formik = useFormik({
    initialValues: initialValues(defaultValues),
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <HelpCenterSubCardContainer>
      <div className="wrapper">
        <div className="header">
          <Heading>Contact Us</Heading>
          <IconClose
            fill="#048AF5"
            className="close-icon"
            height={24}
            width={24}
            onClick={handleMenuClose}
          />
          <p>Email us about your issues, and we’ll respond promptly.</p>
        </div>
        <Divider />
        <Form className="form" onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={12}>
              <Input
                disabled={isLoggedInState}
                label="Name*"
                placeholder="Enter Name"
                isInvalid={formik.touched.name && formik.errors.name}
                {...formik.getFieldProps("name")}
              />
            </Col>
            <Col md={12}>
              <Input
                disabled={isLoggedInState}
                label="Email*"
                placeholder="Enter Email"
                isInvalid={formik.touched.email && formik.errors.email}
                {...formik.getFieldProps("email")}
              />
            </Col>

            <Input
              label="Description*"
              type="textarea"
              placeholder="Enter Description......"
              rows={6}
              className="bug-description-input"
              as="textarea"
              isInvalid={
                formik.touched.description && formik.errors.description
              }
              {...formik.getFieldProps("description")}
            />
            <Divider />
            <div className="btn-submit">
              <Button type="submit" disabled={!formik.isValid}>
                {formik.isSubmitting ? <Loader className="on-btn" /> : "Submit"}
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    </HelpCenterSubCardContainer>
  );
};

ContactUs.propTypes = {
  data: PropTypes.object,
  postSubmit: PropTypes.func,
  handleMenuClose: PropTypes.func,
};

export { ContactUs };
